import React from 'react'
import PropTypes from 'prop-types'

import Modal from '../Modal'
import './index.scss'

const { Composed, Header, Body } = Modal

const Wizard = ({ open, onClose, onRequestSubmit, children, headingLabel }) =>
  open && (
    <Composed
      className='ublique-wizard-modal'
      open={open}
      onClose={onClose}
      preventCloseOnClickOutside
      onRequestSubmit={onRequestSubmit}
    >
      <Header>
        <h4 className='bx--modal-header__heading'>{headingLabel}</h4>
      </Header>
      <Body>{children}</Body>
    </Composed>
  )

Wizard.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  setOpen: PropTypes.func,
  children: PropTypes.node.isRequired,
  headingLabel: PropTypes.string.isRequired
}

Wizard.defaultProps = {
  open: true,
  setOpen: () => {},
  onClose: () => {}
}

export default React.memo(Wizard)
